@let structure = bmkStructure();

<div class="modal-header">
  <h4 class="modal-title">{{ 'editBmk.title' | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <div class="mb-3 row">
      <p>{{ 'editBmk.description' | translate}}</p>
      <label class="col-md-5 col-form-label">{{ 'editBmk.label.title' | translate }}: </label>
      <div class="col-md-7">
        <input
          type="text"
          spellcheck="false"
          class="form-control"
          id="groupNameTextInput"
          #bmkNameInput
          [value]="structure.toString()"
          (keydown.enter)="submit(bmkNameInput.value)"
          (input)="bmkStringChanged(bmkNameInput.value)"/>
      </div>
      <p *ngIf="existingBmkNames.length > 1" class="text-danger small">{{ 'editBmk.error.multipleBmks' | translate }}</p>
    </div>
    @if (isBmkStructure(structure)) {
      <table class="table table-sm p-1">
        <tr>
          <td>{{ 'editBmk.table.functionalAssignment' | translate }}</td>
          <td>== ≠</td>
          <td><input type="text" [value]="structure.functionalAssignment.text" (input)="functionalAssignmentChanged($event)"/></td>
        </tr>
        <tr>
          <td>{{ 'editBmk.table.functionDesignation' | translate }}</td>
          <td>=</td>
          <td><input type="text" [value]="structure.functionDesignation.text" (input)="functionDesignationChanged($event)"/></td>
        </tr>
        <tr>
          <td>{{ 'editBmk.table.installationSite' | translate }}</td>
          <td>++</td>
          <td><input type="text" [value]="structure.installationSite.text" (input)="installationSiteChanged($event)"/></td>
        </tr>
        <tr>
          <td>{{ 'editBmk.table.locationDesignation' | translate }}</td>
          <td>+</td>
          <td><input type="text" [value]="structure.locationDesignation.text" (input)="locationDesignationChanged($event)"/></td>
        </tr>
        <tr>
          <td>{{ 'editBmk.table.deviceTag' | translate }}</td>
          <td>-</td>
          <td><input type="text" [value]="structure.deviceTag.text" (input)="deviceTagChanged($event)"/></td>
        </tr>
      </table>
    }
  </div>
</div>
<div class="modal-footer">
  <button type="button" data-testid="close-button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{ 'global.label.cancel' | translate }}
  </button>
  <button
    type="button" data-testid="save-button" class="btn btn-primary btn-forward"
    (click)="submit(bmkNameInput.value)"
  >
    {{ 'global.label.save' | translate }}
  </button>
</div>
